import { render, staticRenderFns } from "./EDrawerHistoricoPlanoLancado.vue?vue&type=template&id=536571b4&scoped=true"
import script from "./EDrawerHistoricoPlanoLancado.vue?vue&type=script&lang=js"
export * from "./EDrawerHistoricoPlanoLancado.vue?vue&type=script&lang=js"
import style0 from "./EDrawerHistoricoPlanoLancado.vue?vue&type=style&index=0&id=536571b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536571b4",
  null
  
)

export default component.exports